import { css } from "styled-components";
const partnershipsPanelErrorDesktopStyles = {
    PanelError: ()=>css`
		background-color: ${({ theme  })=>theme.colors.secondary.light};
	`
};
export default partnershipsPanelErrorDesktopStyles;

//# sourceMappingURL=partnerships.js.map